const SimpleStore = function (data) {
  this._store = data || {};
  this.actions = [];
  this.subscribeActions = [];
};
SimpleStore.prototype.set = function (key, value) {
  this._store[key] =
    typeof value === 'object' ? SimpleStore.utils.clone(value) : value;
};
SimpleStore.prototype.get = function (key) {
  var value = this._store[key];
  return typeof value === 'object' ? SimpleStore.utils.clone(value) : value;
};
SimpleStore.prototype.addAction = function (key, cb) {
  this.actions.push({ key: key, cb: cb });
};
SimpleStore.prototype.execAction = function (key, data) {
  var action = this.actions.find(function (action) {
    return action.key === key;
  });
  if (typeof action.cb === 'function') action.cb(this, data);
};
SimpleStore.utils = {};
SimpleStore.utils.clone = function (obj) {
  /** just_clone */
  function getRegExpFlags(regExp) {
    if (typeof regExp.source.flags == 'string') {
      return regExp.source.flags;
    } else {
      var flags = [];
      regExp.global && flags.push('g');
      regExp.ignoreCase && flags.push('i');
      regExp.multiline && flags.push('m');
      regExp.sticky && flags.push('y');
      regExp.unicode && flags.push('u');
      return flags.join('');
    }
  }

  if (typeof obj == 'function') {
    return obj;
  }
  var result = Array.isArray(obj) ? [] : {};
  for (var key in obj) {
    // include prototype properties
    var value = obj[key];
    var type = {}.toString.call(value).slice(8, -1);
    if (type == 'Array' || type == 'Object') {
      result[key] = clone(value);
    } else if (type == 'Date') {
      result[key] = new Date(value.getTime());
    } else if (type == 'RegExp') {
      result[key] = RegExp(value.source, getRegExpFlags(value));
    } else {
      result[key] = value;
    }
  }
  return result;
};

export default SimpleStore;
